import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import type { WatchlistPage, WatchlistQuery } from '../models/creativeWatchlist.types'
import { serializeWatchlistQuery } from '../service/creative/watchlistQuery'
import { decodeWatchlistPage, parseWatchlistBody } from '../service/creative/watchlistRow'

import { appHttp, decodeDto, unwrap } from '@/shared/http'

const FEATURE_OWNED_ERRORS: AxiosRequestConfig = {
  suppressGlobalErrorHandler: true,
  meta: { suppressGlobalErrorHandler: true },
}

/**
 * Google Ads Transparency Center creatives (the watchlist) — contract 27 §6.1 #4
 * (v3 `GoogleCreativesView.vue:422, 479`).
 *
 * Not report data: this is the one non-controller dataset in the module, with its own paging.
 * The body contains bare `NaN`, so the sanitiser is installed HERE as a `transformResponse` and
 * never in a component — v3 duplicated the same inline `JSON.parse(...replace(...))` at both call
 * sites (BE-27-02).
 */
export class CreativeWatchlistApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async listGoogleCreatives(
    accountId: number,
    workspaceId: number,
    query: WatchlistQuery,
    signal?: AbortSignal,
  ): Promise<WatchlistPage> {
    const config: AxiosRequestConfig = {
      ...FEATURE_OWNED_ERRORS,
      transformResponse: [parseWatchlistBody],
    }
    if (signal) config.signal = signal

    const response = await this.http.get(
      `/accounts/${accountId}/workspaces/${workspaceId}/metadata/google-atc/?${serializeWatchlistQuery(query)}`,
      config,
    )
    return decodeDto(unwrap<unknown>(response), decodeWatchlistPage)
  }
}
